import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useAdmissionJourney from './useAdmissionJourney';
import './AdmissionTopNotice.css';

function AdmissionTopNotice() {
  const navigate = useNavigate();
  const {
    shouldShowIncompleteAdmissionBanner,
    isAdmissionFeePaid,
    hasProspectAdmissionNumber,
  } = useAdmissionJourney();

  const noticeContent = useMemo(() => {
    if (isAdmissionFeePaid) {
      return {
        title: 'Complete your admission',
        message: 'Admission fee received. Follow your admission steps for interview updates.',
        actionLabel: 'Admission Steps',
      };
    }

    if (hasProspectAdmissionNumber) {
      return {
        title: 'Complete your admission',
        message: 'Your application reference is ready. Complete the admission fee to continue.',
        actionLabel: 'Admission Steps',
      };
    }

    return {
      title: 'Complete your admission',
      message: 'Our admissions team is preparing your admission reference. Please check again shortly.',
      actionLabel: 'Admission Steps',
    };
  }, [hasProspectAdmissionNumber, isAdmissionFeePaid]);

  if (!shouldShowIncompleteAdmissionBanner) {
    return null;
  }

  return (
    <div className='admissionTopNoticeWrap'>
      <div className='admissionTopNotice'>
        <div className='admissionTopNoticeCopy'>
          <strong>{noticeContent.title}</strong>
          <span>{noticeContent.message}</span>
        </div>
        <button
          type='button'
          className='admissionTopNoticeButton'
          onClick={() => navigate('/admission-steps')}
        >
          {noticeContent.actionLabel}
        </button>
      </div>
    </div>
  );
}

export default AdmissionTopNotice;
